var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 16,
    height: 16,
    transform: "translate(-1 -3.753)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Campaign"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaign",
    clipPath: "url(#clip-Campaign)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22565",
    "data-name": "Group 22565",
    transform: "translate(1 3.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M0,4.79A15.638,15.638,0,0,0,1.787,3.36H8.042a.983.983,0,0,1,0,1.966H5.183",
    transform: "translate(0 -1.079)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M9.241,3.85l3.407-3.2A.963.963,0,0,1,13.9.832a1.115,1.115,0,0,1,0,1.43L10.146,6.194a3.777,3.777,0,0,1-2.86,1.072H2.462L.988,8.6",
    transform: "translate(-0.317 -0.16)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/Campaign.39f5247f00599e55725a3528aff0863b.svg";
export { ForwardRef as ReactComponent };